import { useState } from "react";
import { Loader2, Pencil, Plus, Trash2 } from "lucide-react";
import { staffApi, errMsg } from "../api";
import { Status } from "../Shell";

const Row = ({ c, onChanged }) => {
  const [name, setName] = useState(c.name);
  const [status, setStatus] = useState({});
  const run = async (fn, msg) => {
    try { await fn(); setStatus({ state: "success", msg }); onChanged(); } catch (err) { setStatus({ state: "error", msg: await errMsg(err) }); }
  };
  return (
    <li className="flex flex-wrap items-center gap-3 p-4" data-testid={`news-category-${c.slug}`}>
      <input className="field-input !py-2 max-w-xs text-sm" value={name} maxLength={50} onChange={(e) => setName(e.target.value)} aria-label="Category name" data-testid={`news-category-${c.slug}-input`} />
      <span className="text-xs text-slate">{c.count} article{c.count === 1 ? "" : "s"}</span>
      <button type="button" disabled={name.trim() === c.name || name.trim().length < 2} onClick={() => run(() => staffApi.patch(`/news/categories/${c.slug}`, { name }), "Renamed.")} className="btn btn-ghost !px-3 !py-1.5 text-xs disabled:opacity-40" data-testid={`news-category-${c.slug}-rename`}><Pencil size={14} /> Rename</button>
      <button type="button" disabled={c.count > 0} title={c.count > 0 ? "Move or delete its articles first" : "Delete category"} onClick={() => run(() => staffApi.delete(`/news/categories/${c.slug}`), "Deleted.")} className="btn btn-ghost !px-3 !py-1.5 text-xs disabled:opacity-40" data-testid={`news-category-${c.slug}-delete`}><Trash2 size={14} /> Delete</button>
      <Status status={status} />
    </li>
  );
};

export const CategoryManager = ({ cats, onChanged }) => {
  const [name, setName] = useState("");
  const [status, setStatus] = useState({});
  const add = async (e) => {
    e.preventDefault();
    setStatus({ state: "loading" });
    try { await staffApi.post("/news/categories", { name }); setName(""); setStatus({}); onChanged(); } catch (err) { setStatus({ state: "error", msg: await errMsg(err) }); }
  };
  return (
    <div className="border border-navy/10 bg-white" data-testid="news-categories-panel">
      <p className="border-b border-navy/10 p-4 font-semibold text-navy">Categories</p>
      <ul className="divide-y divide-navy/10">{cats.map((c) => <Row key={`${c.slug}-${c.name}-${c.count}`} c={c} onChanged={onChanged} />)}</ul>
      <form onSubmit={add} className="flex flex-wrap gap-3 border-t border-navy/10 p-4">
        <input className="field-input !py-2 max-w-xs text-sm" placeholder="New category name" value={name} maxLength={50} onChange={(e) => setName(e.target.value)} aria-label="New category name" data-testid="news-category-new-input" />
        <button type="submit" disabled={name.trim().length < 2 || status.state === "loading"} className="btn btn-navy !px-4 !py-2 text-sm disabled:opacity-50" data-testid="news-category-add-button">
          {status.state === "loading" ? <Loader2 size={14} className="animate-spin" /> : <Plus size={14} />} Add Category
        </button>
        <Status status={status} />
      </form>
    </div>
  );
};
